<template>
  <div class="statement-container">
      <div class="statement" v-for="statement in statements">
        <a v-bind:href="statement.link" target="_blank">
          <img :src="image(statement)">
          <div class="statement-newspaper">{{statement.newspaper}}</div>
          <div class="statement-date">{{statement.date_moment.format("DD.MM.YYYY")}}</div>
          <span class="statement-link">{{statement.text}}</span> <span class="glyphicon glyphicon-menu-right"></span>
        </a>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import raw_statements_lang from "../Content/PressStatements";

let images = require.context("../../assets/img/press", false, /\.png$/);

export default {
  name: "group-press",
  data: function() {
    return {
      statements: []
    };
  },
  mounted: function() {
    let raw_statements = raw_statements_lang[this.$i18n.locale];
    raw_statements.sort((left, right) => {
      return left.date < right.date ? 1 : -1;
    });

    raw_statements.forEach(statement => {
      statement.date_moment = moment(statement.date);
    });

    this.statements = raw_statements;
  },
  methods: {
    image: function(statement) {
      return images("./" + statement.date + ".png");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.statement-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.statement {
  min-width: 32%;
  max-width: 32%;
  display: inline-block;
  padding: 10px;
  flex: 1;

  @include media-phone {
    min-width: 49%;
    max-width: 49%;
  }

  a,
  a:hover {
    color: inherit;
    text-decoration: none;
  }

  &:hover img {
    filter: grayscale(0%);
  }

  img {
    width: 100%;
    filter: grayscale(100%);
    transition: filter 500ms ease;
  }

  .statement-newspaper {
    font-family: $condensed_font;
    font-weight: 700;
    font-size: 26px;

    @include media-phone {
      font-size: 20px;
    }
  }

  .statement-link {
    text-decoration: underline;
    margin-bottom: 10px;
  }

  .glyphicon {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupPress.vue